import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";

export default function LiveStreamFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("live");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const filters = [
    { id: "live", name: "Ao Vivo" },
    { id: "upcoming", name: "Em Breve" },
    { id: "past", name: "Anteriores" },
  ];

  const fetchPosts = useCallback(async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/live_streaming?page=${pageNum}&limit=12`;
      if (filter) url += `&status=${filter}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching live streams:", error);
      setLoading(false);
    }
  }, [filter, user.token]);

  useEffect(() => {
    setPage(1);
    fetchPosts(1);
  }, [filter, fetchPosts]);

  const formatViewers = (count) => {
    if (!count) return "0";
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count.toString();
  };

  if (loading && posts.length === 0) {
    return <div className="livestream_feed_loading"><div className="livestream_loader"></div><span>Carregando lives...</span></div>;
  }

  return (
    <div className="livestream_feed">
      {filters.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {filters.map((filterItem) => (
              <button
                key={filterItem.id}
                className={`filter_btn ${filter === filterItem.id ? "active" : ""}`}
                onClick={() => setFilter(filterItem.id)}
              >
                {filterItem.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="livestream_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
          </svg>
          <h3>Nenhuma live encontrada</h3>
          <p>Seja o primeiro a transmitir ao vivo!</p>
        </div>
      ) : (
        <div className="livestream_grid">
          {posts.map((post) => (
            <div key={post._id} className="livestream_card">
              <div className="livestream_thumbnail">
                <img src={post.liveStreamData?.thumbnail || post.images?.[0]?.url || post.images?.[0] || "/images/default-live.png"} alt="" />
                {post.liveStreamData?.status === "live" && (
                  <span className="livestream_live_badge">
                    <span className="livestream_live_dot"></span>
                    AO VIVO
                  </span>
                )}
                {post.liveStreamData?.status === "upcoming" && (
                  <span className="livestream_upcoming_badge">EM BREVE</span>
                )}
                <div className="livestream_viewers">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                  </svg>
                  {formatViewers(post.liveStreamData?.viewerCount)}
                </div>
              </div>
              <div className="livestream_card_content">
                <Link to={`/profile/${post.user.username}`} className="livestream_streamer">
                  <img src={post.user.picture} alt="" />
                  <div className="livestream_streamer_info">
                    <span className="livestream_name">{post.user.first_name} {post.user.last_name}</span>
                    <span className="livestream_username">@{post.user.username}</span>
                  </div>
                </Link>
                <h3>{post.liveStreamData?.title || post.text}</h3>
                <div className="livestream_tags">
                  {post.liveStreamData?.tags?.slice(0, 3).map((tag, i) => (
                    <span key={i}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="livestream_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais lives"}
          </button>
        </div>
      )}
    </div>
  );
}
